export const SbpStateEnum = Object.freeze({ New: 0, Waiting: 1, Paid: 2, Cancelled: 3, Error: 4, Reversed: 5 })
